/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import './slideshows.js'
import responsiveNav from './responsive-nav.js'


(($) => {

    // Make nav menu nice & responsive
        const mainNav = document.querySelector('nav.main-nav');
        if( mainNav ){
            responsiveNav(mainNav,{
                desktopEms: '64em', // size of screen for desktop menu, should match less media query for @desktop-menu
                wrapperSelector: '.main-nav',
                navType: 'offCanvas',
                closeOnOutsideClick: true
            });
        }
        

    // Responsive Videos
    $('.rtecontent').fitVids();

	// ALERT BAR
	if( $('.alert-bar') ){
        var alertbar = $('.alert-bar');
        var closealertbar = $('.close-alertbar');

        $(closealertbar).on('click', function(e){
            e.preventDefault();
            //close the alertbar
            alertbar.slideUp();
            // persist the dismissal in a cookie
            document.cookie = closealertbar.data('alert-cookie');
        });
    }

    if( $('#tribe-tickets__tickets-form').is(':visible') ){
        $('#tribe-tickets__tickets-form-headline').show(); //get tickets headline
    }


})(jQuery)
